import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-sales-card-modal',
  templateUrl: './sales-card-modal.component.html',
  styleUrls: ['./sales-card-modal.component.scss']
})
export class SalesCardModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  countries = null
  data = null
  employees = null
  types = null
  branches = null
  Success = null

  stateForm = new FormGroup({
    id: new FormControl('', Validators.required),
    employee_id: new FormControl('', Validators.required),
    branch_code: new FormControl('', Validators.required),
    fin_year: new FormControl('2020-2022', Validators.required),
    card_type: new FormControl('', Validators.required),
    barcode_no: new FormControl('', Validators.required),
    card_comm: new FormControl('', Validators.required),
    date_from: new FormControl('', Validators.required),
    date_to: new FormControl('', Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }
  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      employee_id,
      branch_code,
      fin_year,
      card_type,
      barcode_no,
      card_comm,
      date_from,
      date_to,
    } = this.stateForm.value;
    this.auth
      .postSalesCard(
        id,
        employee_id,
        branch_code,
        fin_year,
        card_type,
        barcode_no,
        card_comm,
        date_from,
        date_to,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth
      .getBranches()
      .subscribe(
        (resSuccess) => {

          this.branches = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
      this.auth
      .getEmployees()
      .subscribe(
        (resSuccess) => {

          this.employees = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
      this.auth
      .getCard()
      .subscribe(
        (resSuccess) => {

          this.types = resSuccess
        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    this.auth
      .getSalesCard()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        } 
      );
  }
  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      id: title.id,
      employee_id: title.employee_id,
      branch_code: title.branch_code,
      fin_year: title.fin_year,
      card_type: title.card_type,
      barcode_no: title.barcode_no,
      card_comm: title.card_comm,
      date_from: title.date_from,
      date_to: title.date_to,
    });
    console.log(this.stateForm.value)
  }


}
